export const SET_TOKEN = 'SET_TOKEN'
export const SET_ROLES = 'SET_ROLES'
export const RESET_LOGIN = 'RESET_LOGIN'
export const SET_PASSTHROUGH = 'SET_PASSTHROUGH'

export const SESSION_ROLES_NAME = 'auth/roles'
export const SESSION_TOKEN_NAME = 'auth/token'
export const SESSION_USER_PROFILE = 'auth/profile'
export const SESSION_PRIMARY_ROLE = 'auth/primaryRole'
export const SESSION_PHONE_NUMBER = 'auth/phoneNumber'
export const SESSION_PHONE_EXTENSION = 'auth/phoneExtension'



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js